import React from "react";

/**
 * Helper function to format answer values based on question type
 */
export const formatAnswer = (value, questionType) => {
  if (value === null || value === undefined) return null;

  switch (questionType) {
    case 'multi_choice':
      return Array.isArray(value) ? value.join(', ') : value;
    case 'rating_scale':
      return `Rating: ${value}`;
    case 'checkbox':
      return value ? 'Yes' : 'No';
    case 'single_choice':
    case 'text_short':
    case 'text_long':
    default:
      return String(value);
  }
};

/**
 * AnswersTable Component
 * Displays answers for a specific question from all submissions
 * Props:
 * - questionIndex: The index of the question to display answers for
 * - submissions: Array of submission objects with employee and answers data
 * - questionType: Type of question (affects answer formatting)
 */
export default function AnswersTable({ questionIndex, submissions, questionType }) {
  const answers = submissions.map(sub => {
    const answer = sub.answers?.find(a => a.questionIndex === questionIndex);
    const firstName = sub.employee?.firstName || '';
    const lastName = sub.employee?.lastName || '';
    const name = `${firstName} ${lastName}`.trim() || 'Unknown';
    const initials = `${firstName.charAt(0) || ''}${lastName.charAt(0) || ''}`.toUpperCase() || '??';

    return {
      id: sub._id,
      name,
      email: sub.employee?.email || '',
      position: sub.employee?.companyRole || sub.employee?.role?.name || 'Staff',
      avatar: initials,
      submitted: sub.submittedAt ? new Date(sub.submittedAt).toLocaleString() : 'N/A',
      answer: formatAnswer(answer?.value, questionType),
    };
  }).filter(a => a.answer !== null); // Only show if answered

  if (answers.length === 0) {
    return <div className="cd-qa-empty">No answers yet for this question.</div>;
  }

  return (
    <table className="cd-qa-table">
      <thead>
        <tr>
          <th>
            <input type="checkbox" className="cd-qa-checkbox" />
          </th>
          <th>Employee Name</th>
          <th>Position</th>
          <th>Submitted</th>
          <th>Answers (Preview)</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {answers.map((row) => (
          <tr key={row.id}>
            <td>
              <input type="checkbox" className="cd-qa-checkbox" />
            </td>
            <td>
              <div className="cd-qa-employee">
                <div className="cd-qa-avatar">{row.avatar}</div>
                <div className="cd-qa-employee-info">
                  <div className="cd-qa-employee-name">{row.name}</div>
                  <div className="cd-qa-employee-email">({row.email})</div>
                </div>
              </div>
            </td>
            <td className="cd-qa-position">{row.position}</td>
            <td className="cd-qa-submitted">{row.submitted}</td>
            <td className="cd-qa-answer">{row.answer}</td>
            <td className="cd-qa-actions">
              <button className="cd-qa-menu-btn">...</button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
